import React, { useContext } from "react";
import CertificationSessionContext from "module/certificationSession/context/CertificationSessionContext";
import { CertificationSessionInterface } from "module/certification/types";
import CertificationSessionTableRowCategoryContainer from "./category/CertificationSessionTableRowCategoryContainer";
import CertificationSessionTableRowItemContainer from "./item/CertificationSessionTableRowItemContainer";

const CertificationSessionTableRowContainer: React.FC = () => {
  const { entity } = useContext(CertificationSessionContext);

  const certificationSession = entity as CertificationSessionInterface;

  return certificationSession.isCategory ? (
    <CertificationSessionTableRowCategoryContainer />
  ) : (
    <CertificationSessionTableRowItemContainer />
  );
};

export default React.memo(CertificationSessionTableRowContainer);
